import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Icons from '../../../assets/icons/index'
import styled from './SaleOrderList.module.css'
import { useSelector } from "react-redux"
import callApi from "../../../services/api/apiClient"
import LoadingComponent from "../../../components/loading/LoadingComponent"
import ModalProvider from "../../../components/modal/ModalProvider"
import { saleOrderSlice } from "../../../helper/customSlice"
import { Pagination } from "@mui/material"
import { dispatchStore } from "../../../lib/dispatchStore"
import { useToast } from "../../../components/toast/Toast"

const SaleOrderList = () => {
    const navigate = useNavigate()
    // const saleOrderList = useSelector(state => state?.saleOrder?.saleOrderList?.data);
    const saleOrderList = useSelector(state => state?.saleOrderSlice?.list);
    console.log('sale order list...', saleOrderList)
    const Listpage = useSelector((state) => state?.saleOrderSlice?.Listpage)
    const TotalPage = useSelector((state) => state?.saleOrderSlice?.TotalPage)
    const totalAmount = useSelector((state) => state?.saleOrderSlice?.totalAmount)
    const reachEnd = useSelector((state) => state?.saleOrderSlice?.reachEnd)
    const [isDelete, setIsDelete] = useState(false)
    const [orderId, setOrderId] = useState(null)
    const { showToast } = useToast()

    useEffect(() => {
        getSaleOrderList()
    }, [Listpage]);

    const getSaleOrderList = () => {
        let params = {
            page_no: Listpage,
            per_page: 10,
        };
        callApi("saleOrder/saleOrderList")
            .withParam(params)
            .loadingGroup("saleOrderList")
            .execute()
            .then((res) => {
                dispatchStore(saleOrderSlice.actions.setSaleOrderList(res))
            });
    }

    const onDeleteSaleList = () => {
        callApi('saleOrder/deleteSaleOrder')
            .withKeyParameter({ saleOrderId: orderId })
            .execute()
            .then((res) => {
                if (res?.status === 'success') {
                    getSaleOrderList()
                    setIsDelete(false)
                    showToast('Delete Sale Order is successful!', 'success');
                } else {
                    console.log("Error", res?.error)
                    setIsDelete(false)
                    showToast(res?.message ? res?.message : res?.error, 'error');
                }
            })
    }

    console.log(" sale order list...", saleOrderList)

    const handleChange = (event, value) => {
        console.log("This is pagination page no", value)
        if (Listpage != undefined && reachEnd == false) {
            dispatchStore(saleOrderSlice.actions.plusListpage(value))
        }
    };

    return (
        <div className={styled.list_container}>
            <LoadingComponent loadingGroup={"saleOrderList"}>
                <div className="flex items-center">
                    <img src={Icons.back} alt="" className="w-[24px] h-[24px]" />
                    <p className={styled.title}>Sale Order List - LS02569</p>

                    <div className={styled.amount_container}>
                        <span className={`${styled.amount} font-interRegular`}>Total Sale Amount : </span>
                        <span className={`${styled.amount} font-interSemiBold`}>{totalAmount}</span>
                    </div>
                </div>
                {
                    saleOrderList?.length > 0 ?
                        <table className="flex-1 table-auto w-full mt-[40px]">
                            <thead className="text-left">
                                <tr className={styled.table_header_row}>
                                    <th className="">Sale Order No.</th>
                                    <th>Customer</th>
                                    <th>Total</th>
                                    <th>Status</th>
                                    <th>Checkup</th>
                                    <th className="text-center">Action</th>
                                    {/* <th className="w-2/12"></th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    saleOrderList?.map((item, index) => (
                                        <tr className="h-[57px] border-b border-b-black-2">
                                            <td className={`${styled.table_body_column} font-interSemiBold`}>
                                                <span className="cursor-pointer">{item?.name}</span>
                                            </td>
                                            <td className={`${styled.table_body_column} font-interRegular`} onClick={() => { navigate(`/sale_order_detail/${item?.id}`) }}>{item?.customer?.name}</td>
                                            <td className={`${styled.table_body_column} font-interRegular`}>{item?.total_amount}</td>
                                            <td>
                                                <div className={`${item?.state === 'draft' ? styled.status_blue : item?.state === 'sale' ? styled.status_green : styled.status_gray} inline-flex`}>
                                                    <span className="capitalize">{item?.state}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className={`${item?.checked ? styled.status_green : styled.status_gray} inline-flex`}>
                                                    <span>{item?.checked ? 'Checked' : 'Unchecked'}</span>
                                                </div>
                                            </td>
                                            <td className="flex-1">
                                                <div className="cursor-pointer  items-center flex justify-center" onClick={() => {
                                                    setOrderId(item?.id)
                                                    setIsDelete(true)
                                                }}>
                                                    <img src={Icons.bin} alt="" className="w-[22px] h-[20px]" />
                                                </div>
                                            </td>
                                            {/* <td className="w-1/12"></td> */}
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        :
                        <div className="flex justify-center items-center h-full">
                            <p className={styled.not_found}>No customer data found.</p>
                        </div>
                }
                {saleOrderList?.length > 0 && TotalPage > 1 &&
                    <div className='flex justify-center mt-3  bottom-0 w-full '>
                        <Pagination count={TotalPage} page={Listpage} onChange={handleChange} color="primary" />
                    </div>
                }
            </LoadingComponent>

            <ModalProvider
                isOpen={isDelete}
                onClose={() => setIsDelete(false)}
                title={'Delete Live Sale Order List'}
                cancelBtn={() => setIsDelete(false)}
                sendBtn={() => onDeleteSaleList()}
                description={'Are you sure you want to  delete this product?'} />
        </div>
    )
}
export default SaleOrderList